export const generalCopy = {
  callToActions: {
    submitFeedback: "Submit Feedback",
    cancelFeedback: "Cancel",
    submitTicket: "Submit a support ticket",
    askQuestion: "Ask a question",
  },
  prompts: {
    preChat: {
      introduction:
        "Intelligent Discovery is an AI-powered collaborator to help you improve your message deliverability by assisting in troubleshooting message errors. Ask any inquiries about your messaging and get potential solutions.\n Beyond its general knowledge of the Twilio Messaging product, it is also informed about your specific context, including your messaging service and console pages.",
      rootCause: "What is the root cause?",
      showMessagesWithError: "Show me messages with the error",
    },
  },
  feedback: {
    helpfulLabel: "Is this helpful?",
    feedbackCategoryLabel: "What can we improve on?",
    feedbackCategoryOptions: [
      "Information is oudated or incorrect.",
      "Information is missing from this answer,",
      "It doesn't immediately fix my issues.",
      "Other",
    ],
    supportLabel: "Need additional support?",
  },
  reply: {
    suggested: "Suggested reply",
    giveRecommendations: "Give me advanced recommendations",
    prevention: "How can I prevent this?",
  },
  tooltips: {
    freeFormQuestionText:
      "You can ask questions related to message errors or messaging traffic directly and receive data analysis, potential suggestions, and recommendations. Any data that you can filter in Messaging Insights can be supported, e.g., Carriers, Countries, Channels, Error codes...",
    freeFormQuestionExamplesIntro:
      "Here are some examples of potential questions the assistant can support:",
    freeFormQuestionExamples: [
      <>
        Messages that I sent are <b>undelivered</b>, can you show what caused
        it?
      </>,
      <>
        Which are the <b>carriers</b> filtering my messages?
      </>,
      <>
        What are the <b>countries</b> of phone numbers that my messages are
        getting undelivered?
      </>,
      <>
        My messages are failed to be sent to <b>Spain</b>. Can you tell me why?
      </>,
      <>
        My messages from <b>WhatsApp</b> failed today. Can you tell me why?
      </>,
    ],
  },
  loaders: {},
  errors: {},
  variants: {},
};

export const messageDeliverabilityEngineCopy = {
  prompts: {
    deliverabilyScoreDown: "Why is my Deliverability Score down?",
    topThreeAlerts: "What are my top 3 urgent Intelligent Alerts?",
    topMessagingErrors: "What are the top messaging errors?",
    toAccounts: "What are the top accounts experiencing issues?",
    messageFiltration: "Why are my messages being filtered?",
    goTo10DLC: "Go to 10DLC Registration",
  },
};

export const intelligentAlertsCopy = {
  prompts: {
    intelligentAlertsGeneral: "How does Intelligent Alerts work?",
    supportedErrorCodes: "What are the supported error codes?",
    impactedMessages: "How many messages are impacted by errors?",
  },
};

export const messagingLogsCopy = {
  prompts: {
    summary: "Give me a summary about my messaging status",
    failedMessages: "Why was my message failed or undelivered?",
    topMessagingErrors: "What are the top messaging errors?",
  },
};

export const demoCopy = {
  errorCodeGuidedFlow: {
    firstUserPrompt:
      "Can you give me a list of top error codes from my messaging account?",
    firstAssistantResponse:
      "Here is the list of error codes with the messaging error for the past 7 days. Select an error code to investigate further.",
    secondUserPrompt: "30007 - Message Filtered",
    secondAssistantResponse: `For 30007 - Message Filtered error for this phone number +1 333-333-3333, We’ve identified that this filtering incident is impacting your traffic going to Verizon US, 354 messages being undeliverable with error code 30007 - Message Filtered.
      
      This is often due to: Your message content is flagged as going against carrier guidelines.\n Your message appears to be spam, phishing, or fraud You use spammy URLs You use the word “test, testing, tests”
      
      You have a “burnt” number\nWe recommend reviewing our guidelines on filtering and scaling to better manage high volumes of messages. Best practices for scaling your messaging use cases using Twilio’s Programmable Messaging include staggering message sends, utilizing multiple phone numbers, and adhering to carrier-specific throughput limits.`,
  },
  phoneNumberGuidedPrompt: {
    firstUserPrompt:
      "Can you give me a list of top countries with message delivery errors?",
    firstAssistantResponse:
      "Here is the list of phone numbers with the messaging error for the past 7 days. Select a phone number to investigate further.",
    secondUserPrompt: "+1 234 567 8901",
    secondAssistantResponse:
      "For the phone number +1 xxx-xxx-xxxx, here are the most frequent errors causing your messages being failed or undelivered. To get suggestions on how to prevent these errors, select an error code below.",
    thirdUserPrompt: "30007 - Message Filtered",
    thirdUserAssistantResponse: `For 30007 - Message Filtered error for this phone number +1 333-333-3333, We’ve identified that this filtering incident is impacting your traffic going to Verizon US, 354 messages being undeliverable with error code 30007 - Message Filtered.
      
    This is often due to: Your message content is flagged as going against carrier guidelines.\n Your message appears to be spam, phishing, or fraud You use spammy URLs You use the word “test, testing, tests”
    
    You have a “burnt” number\nWe recommend reviewing our guidelines on filtering and scaling to better manage high volumes of messages. Best practices for scaling your messaging use cases using Twilio’s Programmable Messaging include staggering message sends, utilizing multiple phone numbers, and adhering to carrier-specific throughput limits.`,
  },
  countryGuidedPrompt: {
    firstUserPrompt:
      "Can you give me a list of top countries with message delivery errors?",
    firstAssistantResponse:
      "For this country, here are the most frequent errors causing your messages being failed or undelivered. To get suggestions on how to prevent these errors, select an error code below.",
    secondUserPrompt: "30007 - Message Filtered",
    secondAssistantResponse: `For 30007 - Message Filtered error for this phone number +1 333-333-3333, We’ve identified that this filtering incident is impacting your traffic going to Verizon US, 354 messages being undeliverable with error code 30007 - Message Filtered.
      
    This is often due to: Your message content is flagged as going against carrier guidelines.\n Your message appears to be spam, phishing, or fraud You use spammy URLs You use the word “test, testing, tests”
    
    You have a “burnt” number\nWe recommend reviewing our guidelines on filtering and scaling to better manage high volumes of messages. Best practices for scaling your messaging use cases using Twilio’s Programmable Messaging include staggering message sends, utilizing multiple phone numbers, and adhering to carrier-specific throughput limits.`,
  },
  messageSidGuidedPrompt: {
    firstUserPrompt: "I have a specific message to troubleshoot?",
    firstAssistantResponse:
      "Please provide a MessageSID of the message you’d like to troubleshoot. You can find it from Messaging Logs.",
    secondUserPrompt: "SMXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
    secondAssistantResponse: `
    For the message SID “SMXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX”,Your message was failed to sent by being filtered (blocked) by Twilio or by the carrier.

    30007 (Message filtered): This error signifies that the message was filtered and it did not reach its destination. This phenomena often results due to carrier filtering, prohibiting certain types of messages.
    ...... (content pulling from the Help Center articles)

    Do you want to see other messages for the same errors?`,
  },
};
